'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNotes(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M.924 8.577h6.723c.51 0 .924.384.924.857 0 .44-.356.802-.816.852l-.108.005H.924c-.51 0-.924-.383-.924-.857 0-.44.357-.802.817-.851l.107-.006h6.723H.924zM11.12 5.15c.486 0 .88.383.88.857a.869.869 0 01-.88.857H.88A.869.869 0 010 6.006c0-.474.394-.857.88-.857h10.24zM.88 1.72h10.24c.486 0 .88.384.88.857 0 .44-.34.802-.777.852l-.103.005H.88A.869.869 0 010 2.577c0-.44.34-.802.777-.851L.88 1.72h10.24H.88z", id: "Notes__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Notes__svg__a" })))));
}

module.exports = SvgNotes;
//# sourceMappingURL=Notes.js.map
